import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import StarfieldBackground from './StarfieldBackground';
import SpaceEnterButton from './SpaceEnterButton';
import './EnterGate.css';

const EnterGate = ({ onEnter, name = 'FAIZI', subtitle = 'Growth Manager - AI Developer' }) => {
  const rootRef = useRef(null);
  const contentRef = useRef(null);
  const flashRef = useRef(null);
  const doneRef = useRef(false);

  useEffect(() => {
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !contentRef.current) return;

    gsap.fromTo(
      contentRef.current.children,
      { y: 18, opacity: 0, filter: 'blur(10px)' },
      {
        y: 0,
        opacity: 1,
        filter: 'blur(0px)',
        duration: 0.75,
        stagger: 0.08,
        ease: 'power3.out',
        delay: 0.12,
      }
    );
  }, []);

  const handleEnter = () => {
    if (doneRef.current) return;
    doneRef.current = true;

    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      onEnter?.();
      return;
    }

    const tl = gsap.timeline({ onComplete: () => onEnter?.() });

    tl.to(contentRef.current, {
      y: -24,
      opacity: 0,
      filter: 'blur(8px)',
      duration: 0.32,
      ease: 'power3.in',
    });

    if (flashRef.current) {
      tl.to(flashRef.current, { opacity: 0.36, duration: 0.1, ease: 'power2.out' }, '-=0.08').to(
        flashRef.current,
        { opacity: 0, duration: 0.28, ease: 'power2.in' }
      );
    }

    tl.to(rootRef.current, { opacity: 0, duration: 0.42, ease: 'power2.in' }, '-=0.25');
  };

  return (
    <div className="enter-gate" ref={rootRef} aria-label="Portfolio intro">
      <div className="enter-gate__bg" aria-hidden="true">
        <StarfieldBackground />
      </div>

      <div className="enter-gate__content" ref={contentRef}>
        <span className="enter-gate__kicker">Portfolio 2026</span>
        <h1 className="enter-gate__name">{name}</h1>
        <p className="enter-gate__subtitle">{subtitle}</p>
        <p className="enter-gate__summary">Web3 growth, AI automation, Telegram systems, and product execution.</p>

        <SpaceEnterButton onClick={handleEnter} label="ENTER" />
      </div>

      <span className="enter-gate__flash" ref={flashRef} aria-hidden="true" />
    </div>
  );
};

export default EnterGate;